
const EventDate = (cell) => {
    return cell.value ? cell.value : '';
};
const Address = (cell) => {
  return cell.value ? cell.value.split('\n').join(', ') : '';
}; 
const EventCreatedBy = (cell) => {
    return cell.value ? cell.value : '';
};

const EventCreatedDate = cell => {
  return cell.value ? cell.value : ""
}

const Ceremony = (cell) => {
  return cell.value ? cell.value : '';
};

const Description = cell => {
  return cell.value ? cell.value : 0
}



const EventBudget = cell => {
  return cell.value ? cell.value : ""
}

const EventNumberOfAttendees = cell => {
  return cell.value ? cell.value : ""
}




export {
  Address,
  EventNumberOfAttendees,
  EventBudget,
  Description,
  Ceremony,
  EventCreatedDate,
  EventCreatedBy,
  EventDate,
}